import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

// Web 端统一请求封装：自动携带登录 Token（复用 Django 后台账号 + DRF Token）
const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
})

// 请求拦截：附带 Web 登录 Token
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('ems_web_token')
    if (token) {
      config.headers.Authorization = 'Token ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截：401 清空 Token 并跳登录页；5xx 给出友好提示
api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status
    if (status === 401) {
      localStorage.removeItem('ems_web_token')
      localStorage.removeItem('ems_web_username')
      if (router.currentRoute.name !== 'Login') {
        router.replace({ name: 'Login' })
      }
    } else if (!status) {
      // 网络不通：请求根本没有 HTTP 响应（断网 / 超时 / DNS 失败 / 跨域被拦）
      Message.closeAll()
      Message.warning('网络无法连接后端服务，请检查网络连接后重试')
    } else if (status >= 500) {
      // 服务器内部错误，与网络无关，不应误报成"未连接"
      Message.closeAll()
      Message.error('服务器异常（HTTP 500），请稍后重试或联系管理员')
    }
    return Promise.reject(error)
  }
)

export default api
